import script from "./PCPartsDetailsCardArticlesReal.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardArticlesReal.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardArticlesReal.vue?vue&type=style&index=0&id=490ef087&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490ef087"]])

export default __exports__